import { createSelector } from '@ngrx/store';
import { getMemberInterfaceUserData } from '../getMemberInterfaceUserData/get-member-interface-user-data.selector';

export const getMemberInterfaceUserDataForCredentialType = (credentialType: OLO.Enums.MEMBER_INTERFACE_CREDITENTIAL_TYPE) =>
    createSelector(getMemberInterfaceUserData, (memberInterfaceUserData) =>
        memberInterfaceUserData?.data?.find((memberInterface) => memberInterface.CredentialType === credentialType),
    );
